export default __webpack_public_path__ + "static/about_us-24589aa49a368b330375540c51a34e40.png";